import store from '../store';
import * as actions from "./settingsTypes";
import { handleAxiosPost, handleAxiosGet } from '../axiosHelper';

export const getRoleList = async (paramValues) => {
    const url = '/User/GetRoleList';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SET_ROLE_LIST, payload: { list: responseData } });

        return responseData;
    }
    else {
        return responseData;
    };
};

export const getAuthorizationList = async (paramValues) => {
    const url = '/User/GetAuthorizationList';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SET_AUTHORIZATION_LIST, payload: { list: responseData } });

        return responseData;
    }
    else {
        return responseData;
    };
};

export const getAuthorizedPages = async (paramValues) => {
    const url = '/User/GetAuthorizedPages';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SET_AUTHORIZED_PAGES, payload: { list: responseData } });

        return responseData;
    }
    else {
        return responseData;
    };
};

export const saveAuthorization = async (payload) => {
    const url = '/User/SaveAuthorization';
    const contentType = "application/json";
    const data = payload;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    }
    else {
        return responseData;
    };
};

export const getUserList = async (paramValues) => {
    const url = '/User/GetUserList';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SET_USER_LIST, payload: { list: responseData } });

        return responseData;
    }
    else {
        return responseData;
    };
};

export const getUserData = async (paramValues) => {
    const url = '/User/GetUserData';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        return responseData;
    }
    else {
        return responseData;
    };
};

export const saveUser = async (payload) => {
    const url = '/User/SaveUser';
    const contentType = "multipart/form-data";
    const data = payload;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    }
    else {
        return responseData;
    };
};

export const saveBulkUser = async (payload) => {
    const url = '/User/BulkUserUpload';
    const contentType = "application/json";
    const data = payload;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    }
    else {
        return responseData;
    };
};

export const saveRole = async (payload) => {
    const url = '/User/SaveRole';
    const contentType = "application/json";
    const data = payload;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    }
    else {
        return responseData;
    };
};

export const getCustomerList = async (paramValues) => {
    const url = '/User/GetCustomerList';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SET_CUSTOMER_LIST, payload: { list: responseData } });

        return responseData;
    }
    else {
        return responseData;
    };
};

export const getUserDataList = async (paramValues) => {
    const url = '/User/GetUserDataList';
    const params = paramValues;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SET_USER_DATA_LIST, payload: { list: responseData } });
        return responseData;
    }
    else {
        return responseData;
    };
};

export const assignRole = async (paramValues) => {
    const url = '/User/AssignRole';
    const contentType = "application/json";
    const data = paramValues;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    }
    else {
        return responseData;
    };
};

export const copyAuthorization = async (paramValues) => {
    const url = '/User/CopyAuthorization';
    const contentType = "application/json";
    const data = paramValues;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    }
    else {
        return responseData;
    };
};

/* -----Email----- */

export const getEmailCredential = async (item) => {
    let url = '/Settings/GetEmailCredentials';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETEMAILCREDENTIALLIST, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const saveEmailCredential = async (item) => {
    let url = '/Settings/SaveEmailCredentials';
    let contentType = "application/json";
    let data = item;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    } else {
        return responseData;
    }
};

export const getEmailContent = async (item) => {
    let url = '/Settings/GetEmailContent';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETEMAILCONTENTLIST, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const saveEmailContent = async (item) => {
    let url = '/Settings/SaveEmailContent';
    let contentType = "application/json";
    let data = item;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    } else {
        return responseData;
    }
};

/* -----Quick Create----- */

export const getServiceCallOriginList = async (item) => {
    let url = '/Settings/GetServiceCallOriginList';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETSERVICECALLORIGINLIST, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const getQuickCreateSetting = async (item) => {
    let url = '/Settings/GetQuickCreateSetting';
    let params = item;

    const { data: responseData } = await handleAxiosGet(url, params);

    if (responseData) {
        store.dispatch({ type: actions.SETQUICKCREATESETTING, payload: { list: responseData } });

        return responseData;
    } else {
        return responseData;
    }
};

export const saveQuickCreateSetting = async (item) => {
    let url = '/Settings/SaveQuickCreateSetting';
    let contentType = "application/json";
    let data = item;

    const { data: responseData } = await handleAxiosPost(url, contentType, data);

    if (responseData.result) {
        return responseData;
    } else {
        return responseData;
    }
};

